import { StatisticsLayout } from "@/shared/layouts";
import CheckPage from "@/refund/pages/check";
import InitPage from "@/refund/pages/init";
import ContractPage from "@/refund/pages/contract";
import WalletPage from "@/refund/pages/wallet";
import ReceiptPage from "@/refund/pages/receipt";

import refund from "./constants";

const routes = [
  {
    path: refund.root.url,
    name: refund.root.name,
    handle: refund.root.meta,
    element: <StatisticsLayout />,
    children: [
      {
        // this route only check if user has been initialized refund service or not
        path: refund.root.url,
        index: true,
        element: <CheckPage />,
      },
      {
        // this route show user that start to initialize refund service
        path: refund.init.url,
        name: refund.init.name,
        handle: refund.init.meta,
        element: <InitPage />,
      },
      {
        // this route show contract to user in initializiation steps
        path: refund.contract.url,
        name: refund.contract.name,
        handle: refund.contract.meta,
        element: <ContractPage />,
      },
      {
        // this route show success or fail callback to user after charging wallet
        path: refund.receipt.url,
        name: refund.receipt.name,
        handle: refund.receipt.meta,
        element: <ReceiptPage />,
      },
      {
        // this route show wallet details
        path: refund.wallet.url,
        name: refund.wallet.name,
        handle: refund.wallet.meta,
        element: <WalletPage />,
      },
    ],
  },
];
export default routes;
